import React from "react";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { fetchMenuJobsByRestaurant } from "../service/menuJobService";
import { getRestaurantId } from "../utils/JwtUtil";

export default function MenuProcessor() {
  const { t } = useTranslation();
  const restaurantId = getRestaurantId();

  const { data: jobs = [], isLoading, isError } = useQuery({
    queryKey: ["menuJobs", restaurantId],
    queryFn: () => fetchMenuJobsByRestaurant(restaurantId),
    enabled: !!restaurantId,
    refetchInterval: 5000,
  });

  if (isLoading)
    return (
      <div className="flex items-center justify-center h-64">
        <span className="loading loading-spinner loading-lg"></span>
      </div>
    );
  if (isError) return <div className="text-red-600">{t("errorLoading")}</div>;

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">{t("menuJobs")}</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {jobs.map((job) => {
          const status = job.status;
          const badgeClass =
            status === "PROCESSING"
              ? "badge badge-info badge-outline animate-pulse"
              : status === "COMPLETED"
              ? "badge badge-success"
              : "badge badge-error";
          return (
            <div
              key={job.id}
              className="card bg-base-100 shadow-lg hover:shadow-xl transition"
            >
              <figure className="relative">
                <img
                  src={`${job.imageUrls[0]}`}
                  alt={`Job ${job.id}`}
                  className="h-40 w-full object-cover"
                />
                <div className={`absolute top-2 right-2 ${badgeClass}`}>
                  {t(status.toLowerCase())}
                </div>
              </figure>
              <div className="card-body p-4">
                <h2 className="card-title">{t("job")} #{job.id}</h2>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}